import Joi from 'joi';
import { useTranslation } from 'react-i18next';

import FormHeader from '../../../../common/FormHeader';
import useForm from '../../../../../hooks/useForm';
import { renderInput, renderButton } from '../../../../common/renderUtils';
import BackButton from '../BackButton';
import SignUpClosedNotice from '../../../../common/SignUpClosedNotice';

const CreateTeam = (props) => {
  const { t } = useTranslation();

  const schema = {
    teamName: Joi.string().max(60).required().label('Team Name'),
  };

  const initialData = { teamName: '' };

  const { data, errors, handleChange, handleSubmit, isFormValid } = useForm(initialData, schema);

  const doSubmit = () => {
    props.onCreateTeam(data.teamName);
  };

  return (
    <form onSubmit={(e) => handleSubmit(e, doSubmit)} className="form-signup">
      <BackButton handler={props.onGoBack} />
      <FormHeader title={t('auth.enterTeamName')} />
      <SignUpClosedNotice />
      {renderInput('teamName', t('auth.teamName'), 'text', data, errors, handleChange)}
      {renderButton(t('auth.createTeam'), isFormValid(), props.callingApi)}
    </form>
  );
};

export default CreateTeam;
